/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DateInputs */

const th_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่`)
};

const en_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const ja_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

const zh_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const es_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const pt_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const id_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal`)
};

const fr_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const tl_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa`)
};

const vi_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

const ko_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜`)
};

const de_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const ru_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const tr_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih`)
};

const it_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const pl_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const uk_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const hi_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख़`)
};

const ar_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التاريخ`)
};

const ms_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh`)
};

const bn_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তারিখ`)
};

const zh_tw2_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const zh_hk2_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const ur_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخ`)
};

const fa_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخ`)
};

const sw_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarehe`)
};

const nl_date = /** @type {(inputs: DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {DateInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const date = /** @type {((inputs?: DateInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DateInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_date(inputs)
	if (locale === "ja") return ja_date(inputs)
	if (locale === "zh") return zh_date(inputs)
	if (locale === "es") return es_date(inputs)
	if (locale === "pt") return pt_date(inputs)
	if (locale === "id") return id_date(inputs)
	if (locale === "fr") return fr_date(inputs)
	if (locale === "tl") return tl_date(inputs)
	if (locale === "vi") return vi_date(inputs)
	if (locale === "ko") return ko_date(inputs)
	if (locale === "de") return de_date(inputs)
	if (locale === "ru") return ru_date(inputs)
	if (locale === "tr") return tr_date(inputs)
	if (locale === "it") return it_date(inputs)
	if (locale === "pl") return pl_date(inputs)
	if (locale === "uk") return uk_date(inputs)
	if (locale === "hi") return hi_date(inputs)
	if (locale === "ar") return ar_date(inputs)
	if (locale === "ms") return ms_date(inputs)
	if (locale === "bn") return bn_date(inputs)
	if (locale === "zh-TW") return zh_tw2_date(inputs)
	if (locale === "zh-HK") return zh_hk2_date(inputs)
	if (locale === "ur") return ur_date(inputs)
	if (locale === "fa") return fa_date(inputs)
	if (locale === "sw") return sw_date(inputs)
	if (locale === "nl") return nl_date(inputs)
	return en_date(inputs)
});